import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import { AuditTrailAccountTable } from '../../../types/AuditTrail'
import { AuditTrailTableBody, AuditTrailTableFooter, AuditTrailTableHeader } from './elements'
import { AuditTrailTableStyles } from './styles/AuditTrailTableStyles'

interface AuditTrailPdfProps {
  data: AuditTrailAccountTable[]
}

export const AuditTrailPdf = ({ data }: AuditTrailPdfProps) => {
  const { t } = useTranslation()
  const { sectionWrapper, title, section, sectionTitle } = AuditTrailTableStyles
  const { wrapper } = commonPdfTableStyles

  return (
    <View style={sectionWrapper}>
      <Text style={title}>{t('vat_declaration.audit_trail')}</Text>
      <View style={wrapper}>
        {data.map((item, index) => (
          <View key={`table-${index}`} style={section}>
            <Text style={sectionTitle}>{item?.tableName || ''}</Text>
            <AuditTrailTableHeader type={item.type} />
            <AuditTrailTableBody line={item} index={index} />
            <AuditTrailTableFooter total={item.total} />
          </View>
        ))}
      </View>
    </View>
  )
}
